import { Button, Col, Form, Input, Row } from 'antd';
import React, { useState } from 'react';
import style from './Login.module.scss'
import { AppState } from '../../store';
import { connect } from 'react-redux';
import ErrorMessage from '../../globals/Components/Error/ErrorMessage';
import { postAccountLoginUser } from "../../store/user/thunks";
import greenwiselogo from '../../globals/images/Layout/greeenWiseW.png';
import { SizeType } from 'antd/es/config-provider/SizeContext';

interface LoginProps {
    postAccountLoginUser?: any
    errorMessage?: any;
}

const Login: React.FC<LoginProps> = (props: LoginProps) => {
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const messageResponse = (
        <ErrorMessage>
            {props.errorMessage?.message.map((item: string | null | undefined) => {
                return <p>{item}</p>
            })}
        </ErrorMessage>
    );
    const onFinish = async (values: any) => {
        const userLoginState = {
            username: values.username,
            password: values.password
        };

        await props.postAccountLoginUser(userLoginState);
    };



    return (
        <div className={style["login-container"]}>
            <Row justify="center">
                <Col>
                    <div className={style["login-card"]}>
                        <img loading="lazy" src={greenwiselogo} alt="GreenWise" height={80} />
                        <Form
                            layout="vertical"
                            name="basic"
                            onFinish={onFinish}
                            size={componentSize as SizeType} >
                            <div className={style["login-card-form"]}>
                                <Form.Item
                                    name="username"
                                    rules={[{ required: true, message: '¡Por favor ingrese su usuario!' }]}>
                                    <Input placeholder="Usuario" className={style["justifyForm"]} />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: '¡Por favor ingrese su contraseña!' }]}>
                                    <Input.Password placeholder="Contraseña" className={style["justifyForm"]} />
                                </Form.Item>
                                {messageResponse}
                                <Form.Item wrapperCol={{ span: 24 }}>
                                    <Button className={style["button"]} htmlType="submit">
                                        Ingresar
                                    </Button>
                                </Form.Item>
                            </div>
                            <div>
                                {process.env.REACT_APP_VERSION as string}
                            </div>
                        </Form>
                    </div>

                </Col>
            </Row>

        </div>

    );
};

const mapStateToProps = (state: AppState) => ({
    errorMessage: state.system.messageResponse
});

export default connect(mapStateToProps, {
    postAccountLoginUser

})(Login);